import Peer from 'skyway-js'

export default {
  install (Vue, options) {
    let peer = new Peer({
      key   : '7a29f9f2-2b42-4fd7-ad87-cec1c7c1c73c',
      debug : 1
    })

    Vue.prototype.$peer = peer
    Vue.prototype.$getPeerRoom = roomId => peer.rooms[roomId]
  }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-skyway/index.js